import Vue from 'vue'
import VueRouter from 'vue-router'
import humanities from '../views/humanities.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'humanities',
    component: humanities
  },
  {
    path: '/siliconValley',
    name: 'siliconValley',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/siliconValley.vue')
  },
  {
    path: '/weStory',
    name: 'weStory',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/weStory.vue')
  },
  {
    path: '/youngPerson',
    name: 'youngPerson',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/youngPerson.vue')
  },
  {
    path: '/culture',
    name: 'culture',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/culture.vue')
  },
  {
    path: '/added',
    name: 'added',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/added.vue')
  },
  {
    path: '/classView',
    name: 'classView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/classView.vue')
  },
  {
    path: '/schoolRecruit',
    name: 'schoolRecruit',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/schoolRecruit.vue')
  },
  {
    path: '/priseRecruit',
    name: 'priseRecruit',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/priseRecruit.vue')
  },
  {
    path: '/InternalReferral',
    name: 'InternalReferral',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/InternalReferral.vue')
  },
  {
    path: '/zhiweiDetail',
    name: 'zhiweiDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/zhiweiDetailView.vue')
  }

]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
})

export default router
